module.exports = __webpack_public_path__ + "img/favicon.5a976cd5.ico";